export const INGREDIENT_ADD =  'constructor/INGREDIENT_ADD';
export const INGREDIENT_REMOVE =  'constructor/INGREDIENT_REMOVE';
export const INGREDIENT_MOVE =  'constructor/INGREDIENT_MOVE';
